import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import "core-js/modules/esnext.promise.all-settled.js";
import { identifyError, identifyRequest, identifySuccess } from './get-token';
import { assignCurrentCart } from '../cart';
import { loadUser } from '../user';
export var handleCallback = function handleCallback() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, _getState, _ref) {
      var auth, token;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            auth = _ref.auth;
            _context.prev = 1;
            dispatch(identifyRequest());
            _context.next = 5;
            return auth.handleCallback();
          case 5:
            token = _context.sent;
            dispatch(identifySuccess(token));
            _context.next = 13;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            dispatch(identifyError(_context.t0));
            throw _context.t0;
          case 13:
            if (!(typeof auth.currentUrlHandlesCallback === 'function')) {
              _context.next = 16;
              break;
            }
            _context.next = 16;
            return Promise.allSettled([
            // If the user has a current cart, associate it with the logged in user
            dispatch(assignCurrentCart()),
            // Load the user as well
            dispatch(loadUser())]);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 9]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};